import logo from './logo.svg';
import './App.css';
import { ThemeProvider } from '@mui/material';
import Routing from './Routing';
import { GlobalThemeProvider } from './Components/Context/CartContext';
import theme from './theme/theme';


function App() {

  return (
    <GlobalThemeProvider>
      {/* <ThemeProvider> */}
      <ThemeProvider theme={theme}>
      <Routing />
      </ThemeProvider>
      {/* </ThemeProvider> */}
    </GlobalThemeProvider>
  );

}

export default App;
